import { render, staticRenderFns } from "./VVideoNew.vue?vue&type=template&id=47c30984&scoped=true&"
import script from "./VVideoNew.vue?vue&type=script&lang=js&"
export * from "./VVideoNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c30984",
  null
  
)

export default component.exports